import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Subscription} from 'rxjs';
import {ReviewReportFormModel} from '../models/review.model';
import {EventsService} from '../../../services/events.service';
import {AuthService} from '../../../services/auth.service';
import {UserService} from '../../../services/user.service';
import {ReviewService} from '../services/review.service';
import {AnalyticsService} from '../../../services/analytics.service';
import {ActivatedRoute} from '@angular/router';
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'app-review-report-print',
  templateUrl: './review-report-print.page.html',
  styleUrls: ['./review-report-print.page.scss'],
})
export class ReviewReportPrintPage implements OnInit, OnDestroy {

    subscriptions: Subscription[] = [];

    environment = null;
    menuVisible = true;

    report_id: number = null;
    report: ReviewReportFormModel = null;
    reportPromise: Promise<ReviewReportFormModel> = null;
    reportValid = false;

    selfUpdatedAt = null;
    managerUpdatedAt = null;
    recordsUpdatedAt = null;

    userType = null;
    level = 'learner';
    type = 'review';

    platform = 'website';

    showCompletedGoals  = false;

    constructor(
        private event: EventsService,
        public authService: AuthService,
        public userService: UserService,
        private reviewService: ReviewService,
        private analytics: AnalyticsService,
        private activatedRoute: ActivatedRoute,
    ) {
        this.environment = environment;
        this.subscriptions.push(
            this.event.subscribe('login', () => {
                this.reportValid = false;
            })
        );
        this.subscriptions.push(
            this.event.subscribe('logout', () => this.reportValid = false)
        );
    }

    ngOnInit(): void {
        this.platform = environment.platform;
        this.report_id = Number(this.activatedRoute.snapshot.paramMap.get('report_id'));
        this.level = this.activatedRoute.snapshot.data.level;
        this.type = this.activatedRoute.snapshot.data.type;
        this.showCompletedGoals = (this.level === 'manager');
    }


    ionViewWillEnter() {
        this.menuVisible = false;
        this.userType = this.authService.getUserType();

        if (this.report === null || !this.reportValid) {
            this.reportPromise = this.reviewService.getMyReviewReport(this.report_id);
        }
    }

    ionViewDidEnter() {
        this.analytics.trackView('My Professional Development Reviews');

        if (this.report === null || !this.reportValid) {
            this.reportPromise.then(data => {
                this.report = data;
                this.reportValid = true;

                this.selfUpdatedAt = this.getLastUpdatedAt(this.report.answers_self.value);
                this.managerUpdatedAt = this.getLastUpdatedAt(this.report.answers_manager.value);
                this.recordsUpdatedAt = [
                    this.getLastUpdatedAt(this.report.answers_note.value),
                    this.getLastUpdatedAt(this.report.feedbacks),
                    this.getLastUpdatedAt(this.report.goals.value),
                ].reduce((a, v) => {
                    return a === null ? v : v && v.localeCompare(a) > 0 ? v : a;
                });
            });
        }
    }

    private getLastUpdatedAt(answers: any) {
        return answers.reduce((last, item) => {
            return item.updated_at !== null ?
                (last.updated_at === null ? item : (last.updated_at > item.updated_at ? last : item))
                : last;
        }, [])?.updated_at ?? null;
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(i => i.unsubscribe());
    }
}
